














































































import { Component, Vue } from 'vue-property-decorator';
import Axios from 'axios';
import { BillData, BillItemGroup, BillSettings } from '@/models/billData';
import { BillResponse } from '@/models/billResponse';
import { Route } from 'vue-router';
import { BillStatusTypes } from '@/enums/billStatusTypes';
import { getGradeYearName } from '@/enums/gradeYears';
import moment from 'moment';
import BillEditor, { BillEditType } from '@/components/bill/billEditor.vue';
import { PaymentStatusTypes } from '@/enums/paymentStatusTypes';
import AvaivaledVue from '@/components/avaivaled.vue';
import { FunctionTypes } from '@/enums/functionTypes';
import { CollectionAgencyTypes } from '@/enums/collectionAgencyTypes';

@Component({
  components: {
    BillEditor,
  },
})
export default class BillDetail extends AvaivaledVue {
  get billId(): string {
    return this.$route.params.billId;
  }

  get pageTitle() {
    return '請求書詳細';
  }

  get billed(): boolean {
    if (!this.billData) {
      return false;
    }
    return this.billData.billStatus === BillStatusTypes.Billed;
  }

  get paid(): boolean {
    if (!this.billData) {
      return false;
    }
    switch (this.billData.paymentStatus) {
      case PaymentStatusTypes.Paid:
      case PaymentStatusTypes.AutoPaid:
        return true;
      default:
        return false;
    }
  }

  get billSettings(): BillSettings {
    return this.$store.state.bill.billSettings;
  }

  get billItemGroups(): BillItemGroup[] {
    return this.$store.state.bill.billItemGroups;
  }

  get collectionAgency(): CollectionAgencyTypes {
    if (!this.user || !this.user.collectionAgency) {
      return CollectionAgencyTypes.None;
    }
    return this.user.collectionAgency;
  }

  public BillEditType = BillEditType;

  public getGradeYearName = getGradeYearName;

  public billData: BillData | null = null;

  public async created() {
    const ok = await this.pageBackCheck(FunctionTypes.Bill);
    if (!ok) {
      return;
    }

    try {
      await this.$store.dispatch('bill/fetchBillSettings');
      await this.$store.dispatch('bill/fetchBillItems');
    } catch (error) {
      //
    }

    try {
      const res = await Axios.get<BillResponse>(`/api/bills/${this.billId}`);
      const resData = res.data;
      this.billData = {
        billId: resData.billId,
        studentId: resData.studentId,
        studentUserId: resData.studentUserId,
        studentName: resData.studentName,
        gradeYear: resData.gradeYear,
        billGradeYear: resData.billGradeYear,
        title: resData.title,
        billNo: resData.billNo,
        billDate: resData.billDate as Date,
        billDateCreationMonth: null,
        billDateCreationDay: 1,
        billMessage: resData.billMessage,
        contactInfo: resData.contactInfo,
        billType: resData.billType,
        billExplanation: resData.billExplanation,
        billLimitDate: resData.billLimitDate as Date,
        billLimitDateCreationMonth: null,
        billLimitDateCreationDay: 31,
        taxRate: resData.taxRate,
        taxType: resData.taxType,
        taxRoundType: resData.taxRoundType,
        billStatus: resData.billStatus,
        billStatusUpdatedAt: resData.billStatusUpdatedAt as Date,
        paymentStatus: resData.paymentStatus,
        paymentStatusUpdatedAt: resData.paymentStatusUpdatedAt as Date,
        items: resData.billDetails.map((item) => ({
          isFree: item.isFree,
          groupType: item.groupType,
          groupName: item.groupName,
          itemId: item.itemId,
          itemName: item.itemName,
          unitPrice: item.unitPrice,
          quantity: item.quantity,
          discountOfPercent: item.discountOfPercent,
          nonTaxable: item.nonTaxable,
        })),
        periodicBillId: resData.periodicBillId,
      };
    } catch (error) {
      this.$router.push({ name: 'BillList' });
    }
  }

  private deactivated() {
    this.$destroy();
  }

  private onQuoteBill() {
    this.$router.push({ path: `/bill/bills/create/${this.billId}` });
  }

  private onEditBill() {
    this.$router.push({ path: `/bill/bills/${this.billId}/edit` });
  }

  private async onDeleteBill() {
    try {
      const message = this.billed
        ? '請求済みの請求書です。削除してよろしいですか？'
        : '請求書を削除します。よろしいですか？';
      await this.$confirm(
        message,
        '請求書削除',
        {
          confirmButtonText: '削除',
          cancelButtonText: 'キャンセル',
          type: 'info',
        }
      );
    } catch (error) {
      return;
    }

    try {
      await Axios.delete(`/api/bills/${this.billId}`);

      this.$router.push({ name: 'BillList' });

      this.$notify.success({
        title: '請求書削除完了',
        message: '請求書を削除しました。',
        position: 'bottom-right',
      });
    } catch (error) {
      this.$notify.error({
        title: '請求書削除エラー',
        message:
          (error.response && error.response.data) || '請求書の削除が失敗しました。',
        position: 'bottom-right',
      });
    }
  }

  private async onChargeBill() {
    if (!this.billData) {
      return;
    }
    try {
      let message = 'この請求書を請求します。よろしいですか？';
      if (this.billData.billDate) {
        const billDateString = moment(this.billData.billDate).format(
          'YYYY年MM月DD日'
        );
        const nowString = moment(new Date()).format('YYYY年MM月DD日');
        if (billDateString !== nowString) {
          message = `請求日が本日（${nowString}）になります。請求してもよろしいですか？`;
        }
      }

      await this.$confirm(message, '請求確認', {
        confirmButtonText: '請求',
        cancelButtonText: 'キャンセル',
        type: 'info',
      });
    } catch (error) {
      return;
    }

    try {
      await Axios.post(`/api/bills/${this.billId}/charge`);

      this.$router.push({ name: 'BillList' });

      this.$notify.success({
        title: '請求完了',
        message: '請求しました。',
        position: 'bottom-right',
      });
    } catch (error) {
      this.$notify.error({
        title: '請求エラー',
        message:
          (error.response && error.response.data) || '請求が失敗しました。',
        position: 'bottom-right',
      });
    }
  }

  private async onDownloadPDF() {
    try {
      const response = await Axios.get(
        `/api/bills/${this.billId}/download-pdf`,
        {
          responseType: 'blob',
        }
      );

      let fileName = '';
      const disposition = response.headers['content-disposition'];
      if (disposition && disposition.indexOf('attachment') !== -1) {
        const matches = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/.exec(
          disposition
        );
        if (matches != null && matches[1]) {
          fileName = decodeURI(matches[1].replace(/['"]/g, ''));
        }
      }

      if (fileName === '') {
        fileName = '請求書.pdf';
      }

      if (!(window.navigator as any).msSaveOrOpenBlob) {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } else {
        const url = (window.navigator as any).msSaveOrOpenBlob(
          new Blob([response.data]),
          fileName
        );
      }
    } catch (error) {
      this.$notify.error({
        title: 'エラー',
        message:
          (error.response && error.response.data) ||
          '請求書のダウンロードに失敗しました',
        position: 'bottom-right',
      });
    }

    window.onbeforeunload = null;
    // this.loading = false;
  }
}
